import { Link } from "react-router-dom";
import { authors, formatViews } from "@/mocks/comics";
import SectionHeading from "@/components/feature/SectionHeading";

export default function AuthorPreview() {
  const top = authors.slice(0, 4);

  return (
    <section className="bg-secondary-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="作者专区"
          title="认识幕后的创作者"
          desc="每一位作者都是一座宝藏。漫蛙漫画网的作者专区让你轻松追踪心仪作者的全部系列作品。"
          action={
            <Link
              to="/authors"
              className="whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold text-primary-700 ring-1 ring-primary-200 transition-colors hover:bg-primary-100"
            >
              进入作者专区 <i className="ri-arrow-right-line ml-1" aria-hidden="true" />
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {top.map((a) => (
            <Link
              key={a.id}
              to="/authors"
              className="group rounded-xl bg-background-50 p-5 ring-1 ring-background-200 transition-colors hover:ring-primary-300"
            >
              <div className="flex items-center gap-3">
                <div className="h-14 w-14 shrink-0 overflow-hidden rounded-full ring-2 ring-primary-200">
                  <img
                    src={a.avatar}
                    alt={`漫画家 ${a.name} 头像`}
                    title={`${a.name} 作者专区`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="truncate font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                    {a.name}
                  </h3>
                  <p className="text-xs text-foreground-500">{formatViews(a.followers)} 人关注</p>
                </div>
              </div>
              <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">{a.intro}</p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {a.works.map((t) => (
                  <span key={t} className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800">
                    {t}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}